import React, { createContext, useContext, useState, useEffect } from 'react';

const THEMES = {
  dark_blue: {
    name: 'Koyu Mavi',
    bg: 'from-gray-950 via-gray-900 to-gray-950',
    header: 'bg-gray-900/80',
    card: 'bg-gray-900',
    cardBorder: 'border-gray-800',
    accent: 'bg-blue-600',
    accentHover: 'hover:bg-blue-700',
    accentText: 'text-blue-400',
    preview: '#3b82f6'
  },
  dark_green: {
    name: 'Koyu Yeşil',
    bg: 'from-gray-950 via-emerald-950/30 to-gray-950',
    header: 'bg-emerald-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-emerald-900/50',
    accent: 'bg-emerald-600',
    accentHover: 'hover:bg-emerald-700',
    accentText: 'text-emerald-400',
    preview: '#10b981'
  },
  dark_purple: {
    name: 'Koyu Mor',
    bg: 'from-gray-950 via-purple-950/30 to-gray-950',
    header: 'bg-purple-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-purple-900/50',
    accent: 'bg-purple-600',
    accentHover: 'hover:bg-purple-700',
    accentText: 'text-purple-400',
    preview: '#a855f7'
  },
  dark_red: {
    name: 'Koyu Kırmızı',
    bg: 'from-gray-950 via-red-950/20 to-gray-950',
    header: 'bg-red-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-red-900/50',
    accent: 'bg-red-600',
    accentHover: 'hover:bg-red-700',
    accentText: 'text-red-400',
    preview: '#ef4444'
  },
  dark_amber: {
    name: 'Koyu Turuncu',
    bg: 'from-gray-950 via-amber-950/20 to-gray-950',
    header: 'bg-amber-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-amber-900/50',
    accent: 'bg-amber-600',
    accentHover: 'hover:bg-amber-700',
    accentText: 'text-amber-400',
    preview: '#f59e0b'
  },
  dark_cyan: {
    name: 'Koyu Turkuaz',
    bg: 'from-gray-950 via-cyan-950/30 to-gray-950',
    header: 'bg-cyan-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-cyan-900/50',
    accent: 'bg-cyan-600',
    accentHover: 'hover:bg-cyan-700',
    accentText: 'text-cyan-400',
    preview: '#06b6d4'
  },
  dark_indigo: {
    name: 'Koyu İndigo',
    bg: 'from-gray-950 via-indigo-950/30 to-gray-950',
    header: 'bg-indigo-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-indigo-900/50',
    accent: 'bg-indigo-600',
    accentHover: 'hover:bg-indigo-700',
    accentText: 'text-indigo-400',
    preview: '#6366f1'
  },
  dark_sky: {
    name: 'Gök Mavisi',
    bg: 'from-gray-950 via-sky-950/30 to-gray-950',
    header: 'bg-sky-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-sky-900/50',
    accent: 'bg-sky-600',
    accentHover: 'hover:bg-sky-700',
    accentText: 'text-sky-400',
    preview: '#0ea5e9'
  },
  dark_teal: {
    name: 'Deniz Yeşili',
    bg: 'from-gray-950 via-teal-950/30 to-gray-950',
    header: 'bg-teal-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-teal-900/50',
    accent: 'bg-teal-600',
    accentHover: 'hover:bg-teal-700',
    accentText: 'text-teal-400',
    preview: '#14b8a6'
  },
  dark_forest: {
    name: 'Orman Yeşili',
    bg: 'from-gray-950 via-green-950/30 to-gray-950',
    header: 'bg-green-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-green-900/50',
    accent: 'bg-green-600',
    accentHover: 'hover:bg-green-700',
    accentText: 'text-green-400',
    preview: '#22c55e'
  },
  dark_lime: {
    name: 'Fıstık Yeşili',
    bg: 'from-gray-950 via-lime-950/30 to-gray-950',
    header: 'bg-lime-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-lime-900/50',
    accent: 'bg-lime-600',
    accentHover: 'hover:bg-lime-700',
    accentText: 'text-lime-400',
    preview: '#84cc16'
  },
  dark_yellow: {
    name: 'Koyu Sarı',
    bg: 'from-gray-950 via-yellow-950/20 to-gray-950',
    header: 'bg-yellow-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-yellow-900/50',
    accent: 'bg-yellow-600',
    accentHover: 'hover:bg-yellow-700',
    accentText: 'text-yellow-400',
    preview: '#eab308'
  },
  dark_orange: {
    name: 'Alev Turuncu',
    bg: 'from-gray-950 via-orange-950/20 to-gray-950',
    header: 'bg-orange-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-orange-900/50',
    accent: 'bg-orange-600',
    accentHover: 'hover:bg-orange-700',
    accentText: 'text-orange-400',
    preview: '#f97316'
  },
  dark_rose: {
    name: 'Koyu Gül',
    bg: 'from-gray-950 via-rose-950/20 to-gray-950',
    header: 'bg-rose-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-rose-900/50',
    accent: 'bg-rose-600',
    accentHover: 'hover:bg-rose-700',
    accentText: 'text-rose-400',
    preview: '#f43f5e'
  },
  dark_pink: {
    name: 'Koyu Pembe',
    bg: 'from-gray-950 via-pink-950/20 to-gray-950',
    header: 'bg-pink-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-pink-900/50',
    accent: 'bg-pink-600',
    accentHover: 'hover:bg-pink-700',
    accentText: 'text-pink-400',
    preview: '#ec4899'
  },
  dark_fuchsia: {
    name: 'Koyu Fuşya',
    bg: 'from-gray-950 via-fuchsia-950/20 to-gray-950',
    header: 'bg-fuchsia-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-fuchsia-900/50',
    accent: 'bg-fuchsia-600',
    accentHover: 'hover:bg-fuchsia-700',
    accentText: 'text-fuchsia-400',
    preview: '#d946ef'
  },
  dark_violet: {
    name: 'Koyu Menekşe',
    bg: 'from-gray-950 via-violet-950/30 to-gray-950',
    header: 'bg-violet-950/80',
    card: 'bg-gray-900',
    cardBorder: 'border-violet-900/50',
    accent: 'bg-violet-600',
    accentHover: 'hover:bg-violet-700',
    accentText: 'text-violet-400',
    preview: '#8b5cf6'
  },
  dark_slate: {
    name: 'Antrasit',
    bg: 'from-gray-950 via-slate-900 to-gray-950',
    header: 'bg-slate-900/80',
    card: 'bg-gray-900',
    cardBorder: 'border-slate-700/50',
    accent: 'bg-slate-600',
    accentHover: 'hover:bg-slate-700',
    accentText: 'text-slate-300',
    preview: '#64748b'
  }
};

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [themeName, setThemeName] = useState(() => {
    return localStorage.getItem('user_theme') || 'dark_blue';
  });

  const theme = THEMES[themeName] || THEMES.dark_blue;

  const changeTheme = (name) => {
    setThemeName(name);
    localStorage.setItem('user_theme', name);
  };

  return (
    <ThemeContext.Provider value={{ theme, themeName, changeTheme, THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};
